import styled from 'styled-components';

const BadgeMedium = styled.div`
  font-size: 18px;
  margin-right: 15px;
  &:hover{
    cursor: pointer;
  }
`
export default BadgeMedium;